/****************ELEMENTS*****************/
//this obj define, the actions realeted to each
//th>table header and td

export const tableDetail = {
  entity: "accountsPayable", //name table on the db
  dest: "accountsPayable", //name of the entity on the system

  //action for body
  //left click, directly to the fullcont
  tdDataDetail: `data-detail='{ "click": [ {"dest":"ripple" },
                                            {"dest":"accountsPayable", "elem":"fullcont", "id":"accountsPayable-fullcont", "act":"callData", "dbid": "#dbid"},
                                            {"dest":"accountsPayable", "elem":"fullcont", "id":"accountsPayable-fullcont", "act":"callUnpaidInvoices", "dbid": "#dbid"}
                                              ],
                                
                                 "clickRight": [{"dest":"accountsPayable", "elem":"dt", "act":"trMenu", "id":"trMenu",  "entity":"report", "dbid": "#dbid" } ]  }'`,

  filter: {
    mainFilterFields: [""],
    mainFilterValues: ["", ""],
    andFilterFields: [""],
    andFilterValues: [""],
  },
};

/****************ELEMENTS*****************/

//each element could organize their data diferent
export function organizeRow(data) {
  //console.log('organizeRow>')

  var newData = [];

  if (data.length === 0) {
    newData.push({
      id: "nothing",
      colum: [
        { label: "No Results", span: "" },
        { label: "", span: "" },
        { label: "", span: "" },
      ],
    });
    return newData;
  }

  data.forEach((elem) => {
    newData.push({
      id: elem.id,
      colum: [
        {
          label: elem.provider,
          span: elem.current,
          style: {
            tdClass: "tdWithAvatar",
            avatar: elem.avatar,
            avatarColor: elem.avatarColor,
            avatarColorLetter: elem.avatarColorLetter,
            avatarLetter: elem.avatarLetter,
          },
        },
        {
          label: elem.total_due_30_days,
          span: "30 days past due"
        },
        {
          label: elem.total_due_31_to_60_days,
          span: "31 to 60 days past due"
        },
        {
          label: elem.total_due_61_to_90_days,
          span: "61 to 90 days past due"
        },
        {
          label: elem.total_due_over_90_days,
          span: "over 90 days past due"
        },
      ],
    }); /*push*/
  }); /*forEach*/

  return newData;
} /*organizeRow*/
